// extracted by mini-css-extract-plugin
module.exports = {"SepTimePie":"SepTimePie_SepTimePie__3UCLW"};